/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown> }} Agent_Scope_Connection_RequiredInputs */



/**
* | output |
* | --- |
* | "Its abilities use {connector}. Pick the {connector} connection it should use." |
*
* @param {Agent_Scope_Connection_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_scope_connection_required = /** @type {((inputs: Agent_Scope_Connection_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Scope_Connection_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seine Fähigkeiten nutzen ${i?.connector}. Wählen Sie die ${i?.connector}-Verbindung, die er nutzen soll.`)
	return /** @type {LocalizedString} */ (`Its abilities use ${i?.connector}. Pick the ${i?.connector} connection it should use.`)
});